import React from "react";
import { Modal } from "antd";
import { Gift, TrendingUp, ArrowRight } from "lucide-react";
import NumberFormat from "react-number-format";

const CartDiscountChoiceModal = ({
  open,
  onClose,
  autoDiscountValue,
  rateConfig,
  weeklyOrderCount,
  onUseAutoDiscount,
  onSaveForThirdOrder,
}) => {
  const remaining = Math.max(0, 3 - weeklyOrderCount - 1);
  const displayAutoDiscount = Number(autoDiscountValue || 0).toLocaleString();
  const wkOrder3rdDiscountPercentage = rateConfig?.wkOrder3rdDiscountPercentage || 60;
  const wkOrder3rdBonusCapped = rateConfig?.wkOrder3rdBonusCapped || 2500;
  const displayPromoCap = Number(wkOrder3rdBonusCapped).toLocaleString();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={true}
      centered
      styles={{ body: { padding: "16px" } }}
    >
      <div className="flex flex-col gap-4">
        <div className="text-center">
          <h2 className="font-gilroyBold text-2xl text-gray-900">
            You Qualify for a Discount!
          </h2>
          <p className="text-gray-600 mt-1">
            Choose how you'd like to save on this order
          </p>
        </div>

        <button
          onClick={onUseAutoDiscount}
          className="w-full p-4 rounded-2xl border-2 border-green-500 bg-green-50 hover:bg-green-100 transition-colors text-left"
        >
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-green-500 flex items-center justify-center flex-shrink-0">
              <Gift className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-gilroyBold text-gray-900">
                Use ₦{displayAutoDiscount} Automatic Discount
              </h3>
              <p className="text-gray-600 mt-1">
                Get an instant discount on this order right now
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-green-600 mt-2 flex-shrink-0" />
          </div>
        </button>

        <div className="flex items-center gap-3">
          <div className="flex-1 h-px bg-gray-200" />
          <span className="text-gray-400 text-sm font-gilroyBold">OR</span>
          <div className="flex-1 h-px bg-gray-200" />
        </div>

        <button
          onClick={onSaveForThirdOrder}
          className="w-full p-4 rounded-2xl border-2 border-orange-400 bg-orange-50 hover:bg-orange-100 transition-colors text-left"
        >
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-orange-500 flex items-center justify-center flex-shrink-0">
              <TrendingUp className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-gilroyBold text-gray-900">
                Add order to meet the 3rd order logic — {wkOrder3rdDiscountPercentage}% Discount
              </h3>
              <p className="text-gray-600 mt-1">
                Save this order for the 3rd order logic. {remaining} more order
                {remaining !== 1 ? "s" : ""} to unlock{" "}
                <span className="font-gilroyBold text-orange-600">{wkOrder3rdDiscountPercentage}% off</span>{" "}
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-orange-500 mt-2 flex-shrink-0" />
          </div>
        </button>
      </div>
    </Modal>
  );
};

export default CartDiscountChoiceModal;
